import { type SpecialRateTickets } from '@parkingbase/ecommerce-api-demo';

import type { TicketSearchResult } from '@/components/myaccount/parking-validation/change-discount/ChangeDiscount.types';

/**
 * Adapts a scanned/searched `TicketSearchResult` (DBTicket extension) to the
 * `SpecialRateTickets` shape expected by `ChargeToAccountModal`.
 *
 * ## Invariants:
 * - `ticketId` is sourced from `DBTicket.id` (the document key), not `ticketNumber`.
 *   Why: `ChargeToAccountModal.handleCharge` passes `ticket.ticketId` as the API
 *   key — the server expects the document ID, not the numeric ticket number.
 * - `owedInGarage` is sourced from `total` on the searched ticket.
 *   Why: `TicketSearchResult` carries `total` (stored running total) but not
 *   `owedInGarage`. The amount is used by `ChargeToAccountModal` to display the
 *   rate and pass to `chargeToAccount(...)`.
 * - `enter` is passed through verbatim (epoch ms); no conversion.
 */
export function toChargeTicket(result: TicketSearchResult): SpecialRateTickets {
  return {
    ticketId: result.id,
    enter: result.enter,
    owedInGarage: result.total ?? 0,
    company: result.company,
  };
}
